<!--收货地址-->
<template>
  <div class="com-table address border">
    <ComAddress :data="formDate1" :maxSize="table.list.length" @edit="submitForm" v-if="show"></ComAddress>
    <div class="address-save">
      <img src="../../assets/images/address/save.png" alt="">
      <span>已保存&nbsp;&nbsp;{{table.list.length}}&nbsp;&nbsp;条地址，还能保存&nbsp;&nbsp;{{20 - table.list.length}}&nbsp;&nbsp;条</span>
    </div>
    <el-table
      :data="reList"
      style="width: 100%">
      <template slot="empty">
        <no-data></no-data>
      </template>
      <el-table-column
        prop="name"
        label="收货人">
      </el-table-column>
      <el-table-column
        prop="area"
        label="所在地区">
      </el-table-column>
      <el-table-column
        prop="address"
        label="详细地址">
      </el-table-column>
      <el-table-column
        prop="postalCode"
        label="邮编">
      </el-table-column>
      <el-table-column
        prop="mobile"
        label="手机号码">
      </el-table-column>
      <el-table-column
        label="操作"
        width="250">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleClick(scope.row.id)">修改</el-button>
          /
          <el-button type="text" size="small" @click="handleDelete(scope.$index, table.list)">删除</el-button>
          <el-tag v-if="!(scope.row.isDefault === 1)" @click="setDefault(scope.row.id, scope.$index)" type="info">
            设为默认地址
          </el-tag>
          <el-tag v-else>默认地址</el-tag>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog width="677px" :visible.sync="dialogFormVisible">
      <EditAddress :data="formDate" @edit="handleEdit" v-if="show"></EditAddress>
    </el-dialog>
  </div>
</template>
<script>
  import Api from '@/api/client/shop-address'
  import ComAddress from '@/components/client/common/comAddress'
  import EditAddress from '@/components/client/common/EditAddress'

  export default {
    inject: ['reload'],
    components: {
      ComAddress,
      EditAddress
    },
    created () {
      this.requestList()
    },
    computed: {
      reList () {
        return this.table.list
      }
    },
    data () {
      return {
        flag: false,
        dialogFormVisible: false,
        show: true,
        table: {
          loading: true,
          list: []
        },
        formDate: {
          add: []
        }
      }
    },
    methods: {
      requestList () {
        Api.getAll(response => {
          let status = response.status
          let body = response.data.list
          if (status >= 200 && status <= 204) {
            this.table.list = body
          } else {
            this.table.list = []
          }
        })
      },
      submitForm (form) {
        this.table.list.unshift(form)
        this.slideTo(420)
        this.formDate1 = {}
        this.show = false
        this.formDate.add = []
        setTimeout(() => { this.show = true }, 0)
      },
      handleClick (id) {
        this.dialogFormVisible = true
        Api.getAdd(id, response => {
          let status = response.status
          let body = response.data
          if (status >= 200 && status <= 204) {
            this.formDate = body
            this.formDate.add = [this.formDate.province, this.formDate.city, this.formDate.area]
          }
        })
        this.show = false
        this.formDate.add = []
        setTimeout(() => { this.show = true }, 0)
      },
      setDefault (id, idx) {
        Api.setDefault(id, response => {
          let status = response.status
          if (status >= 200 && status <= 204) {
            this.table.list.forEach((item, index) => {
              if (idx === index) {
                this.table.list[idx].isDefault = 1
              } else {
                this.table.list[index].isDefault = 0
              }
            })
            this.$message.success('设置默认成功')
          } else {
            this.$message.error('设置默认失败')
          }
        })
      },
      handleDelete (index, rows) {
        let id = rows[index].id
        Api.deleteEdit(id, response => {
          let status = response.status
          if (status >= 200 && status <= 204) {
            rows.splice(index, 1)
            this.$message.success('删除成功！')
          } else {
            this.$message.error('删除失败！')
          }
        })
      },
      handleEdit (data) {
        this.$set(this.table.list, data.index, data)
        this.dialogFormVisible = false
      },
      slideTo (targetPageY) {
        let timer = setInterval(function () {
          let currentY = document.documentElement.scrollTop || document.body.scrollTop// 当前及滑动中任意时刻位置
          let distance = targetPageY > currentY ? targetPageY - currentY : currentY - targetPageY// 剩余距离
          let speed = Math.ceil(distance / 10)// 每时刻速度
          if (currentY === targetPageY) {
            clearInterval(timer)
          } else {
            window.scrollTo(0, targetPageY > currentY ? currentY + speed : currentY - speed)
          }
        }, 10)
      }
    }
  }
</script>
<style scoped lang="scss">
  @import '../../assets/styles/env';

  .address {
    &-save {
      background: #eef6ff;
      height: 32px;
      line-height: 32px;
      border: 1px solid #deeeff;
      margin-bottom: 7px;
      img {
        vertical-align: middle;
        margin: 0 10px;
      }
      span {
        color: $color-gray;
        font-size: $font-secondary;
      }
    }
  }
</style>
<style lang="scss">
  .address {
    .el-button--text {
      color: #666666;
      font-size: 14px;
    }
    .el-button + .el-button {
      margin: 0;
    }
    .el-tag {
      margin-left: 30px;
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/client/ShopAddress.vue